var map = {
	"./black-white_15.webp": 9293,
	"./black-white_16.webp": 2560,
	"./black-white_17.webp": 51,
	"./blackwhite_1.webp": 9955,
	"./blackwhite_14.webp": 8001,
	"./blackwhite_18.webp": 2605,
	"./blackwhite_19.webp": 7666,
	"./blackwhite_2.webp": 5058,
	"./blackwhite_25.webp": 1533,
	"./blackwhite_3.webp": 621,
	"./blackwhite_4.webp": 8252,
	"./blackwhite_5.webp": 6495,
	"./blackwhite_9.webp": 6123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2429;